import { render, staticRenderFns } from "./HeroAside.vue?vue&type=template&id=331ad444&scoped=true&"
import script from "./HeroAside.vue?vue&type=script&lang=js&"
export * from "./HeroAside.vue?vue&type=script&lang=js&"
import style0 from "./HeroAside.vue?vue&type=style&index=0&id=331ad444&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ad444",
  null
  
)

export default component.exports